import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  commands: [],
  command: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/commands/index.js